handleAddVar
<template>
    <div class="formula" id="formula">
        <div
            ref="formulaDesig"
            contenteditable="true"
            placeholder="请输入公式"
            class="formula-design"
            id="formulaDesign"
            @input="_handle_key_input"
            @keyup="saveCurrent"
            @blur="saveCurrent"
        ></div>
        <div v-show="dialog" class="popup" id="popup-selected" @click="closeDialog">
            <ul>
                <li v-for="item of FuncList" :key="item.value" @click="handleAddFun(item)">
                    {{ item.name }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';

let current = null; // 暂存光标信息
let cNode = null;
let pos = null;
const dialog = ref(false);
const _FuncList = [{ name: 'abs', value: 'abs(' }];
const props = defineProps({
    functionList: {
        // 函数集合
        type: Array,
        default: () => []
    },
    variableList: {
        // 变量集合
        type: Array,
        default: () => []
    }
});
const FuncList = computed(() => {
    const arr = [..._FuncList];
    props.functionList.forEach(v => {
        if (!v || !v?.value || _FuncList.some(p => p.value == v?.value)) return;

        arr.push({
            name: v.name,
            value: v.value
        });
    });
    return arr;
});

const _handle_key_input = e => {
    saveCurrent();
    if (e.data === '@') openDialog();

    // 遍历子节点 校验输入字符合法性
    // Object.entries(e.target.childNodes).forEach(arr => {
    //     // 文本节点 且 输入字符是否合法
    //     // if (arr[1].nodeType === 3 && !/^[\d()@/*+-]*$/.test(arr[1].textContent)) {
    //     //     saveCurrent();
    //     //     arr[1].textContent = arr[1].textContent.replace(/[^\d()@/*+-]/g, '');
    //     //     restoreCursorPosition();
    //     // }
    // });
};

// 添加函数
const handleAddFun = i => {
    const newTag = document.createElement('strong');
    newTag.innerHTML = generateHTML('function', i.value, '', i.value, '');
    newTag.setAttribute('contenteditable', false);
    // 移除@符号
    cNode.textContent = cNode.textContent.replace(/@/, '');
    insertTag(newTag, true);
};

// 添加变量
const handleAddVar = (data = {}) => {
    // if(typeof data !== 'Object') return '格式不正确'
    const { id = '', key = '', value = '', type = '' } = data;
    const newTag = document.createElement('strong');
    newTag.innerHTML = generateHTML('variable', value, type, key, id);
    newTag.setAttribute('contenteditable', false);
    // newTag.insertAdjacentText('afterend', '(');
    if (!current) insertAtEnd();
    insertTag(newTag);
};

// 关闭
function closeDialog() {
    dialog.value = false;
}

// 生成html标签字符串
function generateHTML(nodeType, value, type, key, id) {
    return `<span class='${nodeType}' _key="${key}" _id="${id}" _type="${type}">${value}</span>`;
}

// 暂存光标当前信息
function saveCurrent() {
    const select = window.getSelection();
    current = select.getRangeAt(0).cloneRange();
    pos = current.endOffset;
    cNode = select.focusNode;
}

// 光标位置 显示弹窗
function openDialog() {
    const cur_p = getPosition();
    const popup = document.getElementById('popup-selected');
    popup.style.left = cur_p.x - cur_p.domX + 'px';
    popup.style.top = cur_p.y - cur_p.domY + 'px';
    dialog.value = true;
}

// 获取光标位置
// function getCursorPosition() {
//     const selection = window.getSelection();
//     let charIndex = -1;
//     const anchorNode = selection.anchorNode;
//     if (anchorNode) {
//         charIndex = [...anchorNode.textContent].slice(0, selection.anchorOffset).length;
//     }
//     console.log('当前光标位置:', charIndex, selection.anchorOffset);
// }

// 插入标签
function insertTag(dom, isFlag = false) {
    if (!current) return;

    restoreCursorPosition();
    const range = window.getSelection().getRangeAt(0);
    // dom.appendChild(range.extractContents());
    // 判断是否函数表达式，函数自动追加括号
    if (isFlag) {
        /**
         * @desc 此处采用方式一
         * 方式一：通过选区追加，可直接避免光标丢失；
         * 方式二：采用元素追加（例如：insertAdjacentElement）会因
         * textcontenteditable属性导致光标丢失，需额外增加空字符处理；
         *
         */
        // const L_bracket = document.createElement('text');
        // L_bracket.setAttribute('contenteditable', false);
        // L_bracket.innerHTML = '(';
        // range.insertNode(L_bracket);
        range.insertNode(dom);
        dom.insertAdjacentText('afterend', ')');
    } else {
        range.insertNode(dom);
    }

    window.getSelection().collapseToEnd();
    saveCurrent();
}

// 初始化设置光标位置在文本末尾
function insertAtEnd() {
    const div = document.getElementById('formulaDesign');
    // 使用selection API来保存当前光标位置
    const sel = window.getSelection();
    // const range = sel.getRangeAt(0);
    div.focus(); // 确保div可以接收输入
    // 将光标移动到div末尾
    sel.collapse(div, div.childNodes.length);
    // // 插入文本
    // sel.getRangeAt(0).insertNode(text);
    // // 恢复原来的光标位置
    // sel.removeAllRanges();
    // sel.addRange(range);
    // // 移动光标到新的末尾位置
    // const newEnd = document.createTextNode('');
    // div.appendChild(newEnd);
    sel.collapseToEnd();
    saveCurrent();
}

// 获取当前位置
function getPosition() {
    const selection = window.getSelection(); // 光标位置
    if (selection.rangeCount === 0) return false;

    const dom = document.getElementById('formula');
    const dom_rect = dom.getBoundingClientRect();
    // 获取选中区域的范围
    const range = selection.getRangeAt(0);
    // 获取当前光标的坐标点
    const { top, left, height } = range.getBoundingClientRect();

    return {
        domX: dom_rect.left,
        domY: dom_rect.top,
        x: left,
        y: top + height
    };
}

// 恢复光标位置的函数
function restoreCursorPosition() {
    if (!current) return;

    const { startContainer, startOffset } = current;
    const range = document.createRange();
    const selection = window.getSelection();

    pos = pos > 0 ? pos - 1 : pos;
    range.setStart(startContainer, startOffset || pos);
    range.collapse(false);
    selection.removeAllRanges();
    selection.addRange(range);
    document.getElementById('formulaDesign').focus();
}

// 获取公式字符串
function getValueString() {
    const dom = document.getElementById('formulaDesign');
    return dom.textContent;
}

// 获取公式数组值
function getValueList() {
    const dom = document.getElementById('formulaDesign');
    const list = [...dom.childNodes];
    const data = list
        .filter(v => !(v.nodeType === 3 && v.textContent == '')) // 过滤空字符
        .map(v => {
            if (v.nodeType === 1 && v.nodeName === 'STRONG') {
                // 非文本
                const span = v.childNodes[0];
                return {
                    id: span.getAttribute('_id'),
                    value: span.textContent,
                    type: span.getAttribute('_type'),
                    key: span.getAttribute('_key'),
                    nodeType: span.className // 'variable' || 'function'
                };
            }
            return {
                value: v.textContent,
                type: 3
            };
        });
    return data;
}
// 设置公式内容 支持字符串or数组
function setFormula(data) {
    let html='';
    if (Array.isArray(data)) {
        html = data.reduce((total, v) => {
            if (v?.nodeType) {
                const span = generateHTML(v.nodeType, v.value, v.type, v.key, v.id);
                total += `<strong contenteditable="false">${span}</strong>`;
            } else {
                total += v.value;
            }
            return total;
        }, '');
    } else {
        html = convertTags(data);
    }

    document.getElementById('formulaDesign').innerHTML = html;
}
// 自动匹配公式
function matchingFormula() {
    const data = getValueList();
    const html = data.reduce((total, v) => {
        if (v?.nodeType) {
            const span = generateHTML(v.nodeType, v.value, v.type, v.key, v.id);
            total += `<strong contenteditable="false">${span}</strong>`;
        } else {
            total += convertTags(v.value);
        }
        return total;
    }, '');

    document.getElementById('formulaDesign').innerHTML = html;
}

// 字符串匹配标签
function convertTags(data) {
    let _value = data;
    // 函数匹配规则
    FuncList.value.forEach(p => {
        const span = generateHTML('function', p.value, '', p.value, '');
        const str = `<strong contenteditable="false">${span}</strong>`;

        if (_value.indexOf(`${p.value}`) > -1) {
            _value = _value.replaceAll(`${p.value}`, `${str}`);
        }
    });

    // 变量匹配规则
    props.variableList.forEach(p => {
        // value, type, key, id
        const span = generateHTML('variable', p.value, p.type, p.key, p.id);
        const str = `<strong contenteditable="false">${span}</strong>`;

        if (_value.indexOf(`${p.key}`) > -1) {
            _value = regReplace(_value, p.key, str);
        }

        if (_value.indexOf(`${p.value}`) > -1) {
            _value = regReplace(_value, p.value, str);
        }
    });
    return _value;
}

// 只替换非标签内的字符
function regReplace(str, _old, _new) {
    const regex = new RegExp(`<(strong\\b[^<]*(?:(?!<\\/strong>)<[^<]*)*<\\/strong>)|${_old}`, 'g');
    const replacedStr = str.replace(regex, match => {
        if (match === _old) {
            return _new;
        } else {
            return match;
        }
    });
    return replacedStr;
}

// 监听 关闭下拉弹层
watchEffect(() => {
    if (dialog.value) {
        window.addEventListener('click', closeDialog);
    } else {
        window.removeEventListener('click', closeDialog);
    }
});

defineExpose({
    getValueString, // 获取公式字符串值
    getValueList, // 获取公式数组值
    setFormula, // 设置公式内容
    matchingFormula, // 自动匹配公式
    handleAddVar // 插入变量
});
</script>
<style lang="scss">
.bigScreen .formula {
    color: #ffffff; 
}
.formula {
    width: 100%;
    height: 100px;
    position: relative;
    // color: #ffffff;

    &-design {
        width: 700px;
        height: 100px;
        border: 1px solid #999;
        cursor: text;
        outline: none;
        font-size: 14px;
        word-break: break-all;

        &:empty::before {
            content: attr(placeholder);
            color: #969696;
        }
    }

    .popup {
        position: absolute;
        top: 10px;
        left: 20px;
        width: 100px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        box-sizing: border-box;
        z-index: 9999;
        background-color: #fff;

        li {
            font-size: 14px;
            padding: 0 15px;
            position: relative;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #606266;
            height: 34px;
            line-height: 34px;
            box-sizing: border-box;
            cursor: pointer;
        }

        li:hover {
            background-color: #f5f7fa;
        }

        &::before {
            content: '';
            position: absolute;
            top: -5px;
            left: 3px;
            width: 10px;
            height: 10px;
            transform: rotateZ(45deg);
            background-color: #fff;
            border-top: 1px solid #ebeef5;
            border-left: 1px solid #ebeef5;
        }
    }
}

.function {
    color: #0099ff;
    margin: 0 5px;
}
.variable {
    background: #178cdf;
    color: #ffffff;
    padding: 0 5px;
    margin: 0 5px;
    border-radius: 2px;
}

strong {
    font-weight: 400;
}
</style>
